class CustomVideo extends HTMLElement {
        constructor() {
            super();
            this.video = this.querySelector('video');
            this.video.muted = true;
            this.elementChange = this.querySelectorAll('.element-change');
            this.videoMute = this.querySelector('.btn-speak');
            this.videoMute.addEventListener('click', this.toggleMute.bind(this));
            window.addEventListener('resize', this.onResize.bind(this));
            this.init();
                   
        }
        get isTouch() {
          return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
        } 
        
        init() {
           if(!this.isTouch) {
            this.addEventListener('mouseenter', this.playVideo.bind(this));
            this.addEventListener('mouseleave', this.pauseVideo.bind(this)); 
            this.removeEventListener('click', this.toggleVideo.bind(this));   
           } else {
            this.removeEventListener('mouseenter', this.playVideo.bind(this));
            this.removeEventListener('mouseleave', this.pauseVideo.bind(this));
            this.addEventListener('click', this.toggleVideo.bind(this));
           }
           
           
        }
        onResize() {
          this.init();
        }
        toggleVideo() {
            if(this.video.paused) {
                this.playVideo();
               
            }else {
                this.pauseVideo();
            }
        }
        async playVideo() {
            try {
               await this.video.play(); 
               this.video.muted = false;
               this.toggleElementShow();            
            } catch (e) {
                this.pauseVideo();
                throw e;
                
            } 
        }
        toggleMute(e) {
            e.stopPropagation();
            if (!this.video) return;
            this.video.muted = !this.video.muted;
        }
               
        pauseVideo(e) {
            this.toggleElementShow();
            this.video.pause();
        }

        toggleElementShow() {
            this.elementChange.forEach( el => {
                el.classList.toggle('hide');
            })
        }
    }

    customElements.define('custom-video', CustomVideo);